import axios from "axios";
import { GURL } from "./global";

export const GetAllNotificationPositions = (positionId: any) => {
  const url = `${GURL}/Notification/v1/NotificationPosition?positionId=${positionId}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetNotificationPositionById = (Id: any) => {
  const url = `${GURL}/Notification/v1/NotificationPosition/GetById?Id=${Id}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};
export const GetCategoryPositionsByPositionId = (Id: any) => {
  const url = `${GURL}/Notification/v1/NotificationPosition/GetByPositionId?Id=${Id}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};
export const GetAllCategoryPositionsByPositionId = (Id: any) => {
  const url = `${GURL}/Notification/v1/NotificationPosition/GetAllCategoryPositionsByPositionId?Id=${Id}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};
